// modules
import React, { Component } from 'react';
import $ from 'jquery';
import { filter } from 'lodash';
import moment from 'moment';
import { Glyphicon, ListGroupItem } from 'react-bootstrap';

// components
import SaleSkyDashboardCt from './dashboard/SaleSkyDashboardCt';
import { DataListWrapper } from '../../commonComponents/DataTable/DataTablePs';

// js
import parentStateHandler from '../../commonJS/parentStateHandler';
import periodGenerator from '../../commonJS/periodGenerator';
import custJqAjax from '../../commonJS/custJqAjax';
import getFuncTabRoute from '../../commonJS/getFuncTabRoute';
// import searchContent from '../../commonJS/searchContent';


export default class SaleSky extends Component {
	constructor(props) {
		super(props);

		this.handlers = {
			stateHandler: ({ states, newValues }) => {
				parentStateHandler({ states, newValues, parentThis: this });
			},
			optsGenerator: arr => {
				if (!arr) return [];
				let opts = arr.map((item, ind) => {
					return { value: item.id, label: item.name }
				});
				return opts;
			},
			optsCompanyUpdater: () => {
				custJqAjax({
					type: 'GET',
					ajaxsWip: this.ajaxsWip,
					custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
					url: '/api/M_SaleSky_Company.php',
					success: data => {
						let companies = data.result,
							optsCompany = this.handlers.optsGenerator(companies);

						this.setState({ optsCompany });
						// if(!this.props.params.worklogId) this.handlers.optsContactUpdater(companies[0].id);
					}
				});
			},
			optsContactUpdater: (companyId, cb) => {
				custJqAjax({
					type: 'GET',
					ajaxsWip: this.ajaxsWip,
					custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
					data: { company_id: companyId },
					url: '/api/M_SaleSky_Contacts.php',
					success: data => {

						let workLogContacts = data.result,
							optsContact = this.handlers.optsGenerator(workLogContacts);

						this.setState({ workLogContacts, optsContact });
						if (cb) cb();

					}
				});
			},
			workLogDataRefresh: (company_id, cb) => {
				const url = company_id ?
					`/api/W_SaleSky_WorkLog_GetByCompanyId.php?company_id=${company_id}` :
					'/api/W_SaleSky_WorkLog_Get.php';

				custJqAjax({
					type: 'GET',
					ajaxsWip: this.ajaxsWip,
					custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
					url: url,
					success: data => {
						if (!data.result) return;
						this.handlers.logDataProcesser(data.result, company_id, cb);
					}
				});
			},
			logDataProcesser: (data, company_id, cb) => {
				if (company_id) this.handlers.comWorkLogFilter(company_id, data);
				else {
					const result = this.dataProducer(data);

					this.setState({
						workLogOrinData: result.workLogOrinData,
						workLogSortedData: result.workLogSortedData,
						workLogRowsCount: result.workLogRowsCount,
						workLogDefaultSortIndexes: result.workLogDefaultSortIndexes,
						workLogColSortDirs: result.workLogColSortDirs
					});
				}

				// 更新搜尋結果
				if (cb) cb();
			},
			comWorkLogFilter: (company_id, data) => {
				const filterdData = filter(data, ['company_id', company_id]),
					filteredResult = this.dataProducer(filterdData);
				this.setState({
					comWorkLogOrinData: filteredResult.workLogOrinData,
					comWorkLogSortedData: filteredResult.workLogSortedData,
					comWorkLogRowsCount: filteredResult.workLogRowsCount,
					comWorkLogDefaultSortIndexes: filteredResult.workLogDefaultSortIndexes,
					comWorkLogColSortDirs: filteredResult.workLogColSortDirs
				});
			},
			// 遞迴寫法，isUserGroupsChecked的狀態在函數內部(local scope)控制
			updateListsUserGroup: (itemsUserGroup, isUserGroupsChecked, toggledBoxInd) => {
				let len = itemsUserGroup.length;
				if (toggledBoxInd === 0) {
					// 全選/全不選事件
					let isChecked = 'check';

					if (isUserGroupsChecked[0] === 'check') {
						isChecked = 'unchecked';
					}

					for (let i = 0; i < len; i++) {
						isUserGroupsChecked[i] = isChecked;
					}

				} else if (toggledBoxInd > 0) {
					if (isUserGroupsChecked[toggledBoxInd] === 'check') {
						isUserGroupsChecked[toggledBoxInd] = 'unchecked';
						// 全選項目狀態
						isUserGroupsChecked[0] = 'unchecked';
					} else {
						isUserGroupsChecked[toggledBoxInd] = 'check';

						for (var i = 1; i < len; i++) {
							if (isUserGroupsChecked[i] === 'unchecked') break;
						}
						// i可以run到len表示沒有任何unchecked item
						if (i === len) isUserGroupsChecked[0] = 'check';

					}
				}

				let listsUserGroup = itemsUserGroup.map((item, ind) => {
					return (
						<ListGroupItem
							key={ind}
							onClick={e => {
								e.stopPropagation();
								this.handlers.updateListsUserGroup(itemsUserGroup, isUserGroupsChecked, ind);
							}
							}
							style={{ color: item.color_code }}>

							<Glyphicon
								glyph={isUserGroupsChecked[ind]} />

							{item.name}
						</ListGroupItem>
					);
				});

				this.setState({ listsUserGroup, isUserGroupsChecked });
			},
			onWindowWidthChange: () => {
				// 當縮小視窗寬度的速度太快時，會出現無用的y軸捲軸，\
				// (當畫面邊緣覆蓋到table邊線時即會)
				// 此時切換tab會發現y軸捲軸消失，但寬度未變，
				// 導致右側寬度少了y捲軸寬而不平均，
				// 原因為在寬度調整前寬度不足，會有x軸捲軸出現，
				// y軸捲軸是因為x軸捲軸而出現，但寬度調整後，x軸捲軸消失，
				// 實際上y捲軸已無存在必要，但不會消失(畫面未更新造成)，
				// 當切換tab時，由於再次更新畫面，y軸正常消失，但因寬度調整時，
				// 是以當下有x捲軸和y捲軸的情況去計算，會少y捲軸寬度
				// 更新時正常顯示的結果就是右側略寬，
				// 解決方式可在計算寬度值時比較改變後的寬度是否比最小寬度小，
				// 若否則進一步檢查y捲軸正否存在，若是則加入y捲軸調整值

				if (!this.variables.overHeating) {
					this.variables.overHeating = true;

					this.timer = setTimeout(() => {
						const jqEle = $('#div-sidebar-container-pane-third');
						// 如果計算基礎不存在，則等待1秒後重新檢查
						if (!jqEle[0]) {
							this.variables.overHeating = false;
							this.handlers.onWindowWidthChange();
							return;
						}

						let tableWidth = parseFloat(jqEle.css('width'));

						if (!this.state.isBigSideBar) tableWidth -= 186;

						this.setState({ tableWidth });

						this.variables.overHeating = false;

					}, 1000);

				}
			},
			onSidebarSizeToggle: () => {
				this.setState({ isBigSideBar: !this.state.isBigSideBar });
			}
		};

		this.dataProducer = data => {
			let size = data.length,
				defaultSortIndexes = [];

			for (let i = 0; i < size; i++) {
				data[i].visit_start_date = data[i].visit_start_date ? data[i].visit_start_date.slice(0, 10) : "";
				data[i].reg_time = data[i].reg_time.slice(0, 10);
				data[i].worklog_discuss_count = parseInt(data[i].worklog_discuss_count, 10);
				defaultSortIndexes.push(i);
			}
			return {
				workLogOrinData: data,
				workLogSortedData: new DataListWrapper(defaultSortIndexes, data),
				workLogRowsCount: size,
				workLogDefaultSortIndexes: defaultSortIndexes,
				workLogColSortDirs: {}
			};
		};

		this.timer = {};
		this.timeInterval = '';
		this.ajaxsWip = [];
		this.variables = { overHeating: false };

		this.state = {
			// common
			isBigSideBar: true,
			companyInfo: {},
			// overHeating: false,
			workLogOrinData: [],
			workLogSortedData: {},
			workLogRowsCount: 0,
			workLogDefaultSortIndexes: [],
			workLogColSortDirs: {},
			optsCompany: [],
			optsContact: [],
			optsWorkNature: [],
			optsProgressStatus: [],
			optsProjectProgress: [],
			optsProductType: [],
			optsProductModel: [],
			workLogContacts: [],
			tableWidth: 0,
			// for specify company
			comWorkLogOrinData: [],
			comWorkLogSortedData: {},
			comWorkLogRowsCount: 0,
			comWorkLogDefaultSortIndexes: [],
			comWorkLogColSortDirs: {},
			// for calendar
			calendars: [],
			personalEvents: [],
			groupEvents: [],
			listsUserGroup: [],
			isUserGroupsChecked: [],
			itemsUserGroup: [],
			optsJoinCall: [],
			users: [],
			datePeriod: periodGenerator(moment(), 1),
			currentViewDate: new Date(),
			// for product
			productOrinData: [],
			productSortedData: {},
			productDefaultSortIndexes: [],
			productColSortDirs: {},
			// for product categories
			productCategories: {},
			productTreeView: [],
			// for km
			kmOrinData: [],
			kmSortedData: {},
			kmDefaultSortIndexes: [],
			kmColSortDirs: {},
			// for km categories
			kmCategories: {},
			kmTreeView: [],
			// kmDataOk: false 
			// languagesData
			// languageData: { dataNotReady: true },
			// languageCode: localStorage.languageCode || 'zh-tw'
		};
	}

	componentDidMount() {
		// worklog 取得全部log
		custJqAjax({
			type: 'GET',
			ajaxsWip: this.ajaxsWip,
			custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
			url: '/api/W_SaleSky_WorkLog_Get.php',
			success: data => {
				if (!data.result) return;
				// const companyId = this.props.params ? (this.props.params.companyId || "") : "";
				this.handlers.logDataProcesser(data.result, '');

				this.handlers.optsCompanyUpdater();

				custJqAjax({
					type: 'GET',
					ajaxsWip: this.ajaxsWip,
					custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
					url: '/api/M_SaleSky_WorkNature.php',
					success: data => {
						let workNatures = data.result,
							optsWorkNature = this.handlers.optsGenerator(workNatures);

						this.setState({ optsWorkNature });
					}
				});

				// $.get('/api/M_SaleSky_ProductCategories.php', data => {
				//   let productTypes = data.result,
				//       optsProductType = this.handlers.optsGenerator(productTypes);

				//   this.setState({
				//     productTypes,
				//     optsProductType
				//   });

				// 一次性取得全部產品，設定初始選單並提供全部產品資料

				custJqAjax({
					type: 'GET',
					ajaxsWip: this.ajaxsWip,
					custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
					url: '/api/M_SaleSky_Product_Get.php',
					success: data => {

						let productModels = data.result,
							optsProductModel = this.handlers.optsGenerator(productModels);

						this.setState({ optsProductModel });

						// modelIds = productTypes[0].product_ids;

						// this.setState({productModels});

						// this.handlers.optsProductModelUpdater(/*modelIds*/);

					}
				});

				// });

				custJqAjax({
					type: 'GET',
					ajaxsWip: this.ajaxsWip,
					custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
					url: '/api/M_SaleSky_ProgressStatus.php',
					success: data => {

						let progressStatuses = data.result,
							optsProgressStatus = this.handlers.optsGenerator(progressStatuses);

						this.setState({ optsProgressStatus });

					}
				});

				custJqAjax({
					type: 'GET',
					ajaxsWip: this.ajaxsWip,
					custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
					url: '/api/M_SaleSky_ProjectProgress.php',
					success: data => {

						let projectProgress = data.result,
							optsProjectProgress = this.handlers.optsGenerator(projectProgress);

						this.setState({ optsProjectProgress });

					}
				});

				custJqAjax({
					type: 'GET',
					ajaxsWip: this.ajaxsWip,
					custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
					url: '/api/M_SaleSky_UserCompanyInfo.php',
					success: data => {
						const companyInfo = data.result;

						this.setState({ companyInfo });
					}
				});
			}
		});

		// initial table width
		this.handlers.onWindowWidthChange();

		// listen table width size change
		$(window).resize(this.handlers.onWindowWidthChange);

		// 解析低時自動縮小sidebar
		if (parseFloat(window.innerWidth) < 1024) this.handlers.onSidebarSizeToggle();

		this.timeInterval = setInterval(() => {
			custJqAjax({
				type: 'GET',
				ajaxsWip: this.ajaxsWip,
				custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
				url: '/api/M_Servicesky_Notice_Get.php',
				processData: false,
				contentType: false,
				success: res => { }
			});
		}, 180000); // 3*60*1000
	}

	componentWillUnmount() {
		// 清除window resize handler
		$(window).off('resize', this.handlers.onWindowWidthChange);
		// 清除尚未執行的timer
		clearTimeout(this.timer);
		clearInterval(this.timeInterval);
		// 清除進行中的ajax
		this.props.propsPackageFromSkyFamily.ajaxAborter(this.ajaxsWip);
	}

	render() {
		// 語言包未載入完成之前不render
		// 源頭控制可省去下遊多餘的判斷
		// if (this.state.languageData.dataNotReady) return null;

		const { languageData, languageCode } = window.myConsts;

		const {
			workLogOrinData,
			workLogSortedData,
			workLogRowsCount,
			workLogDefaultSortIndexes,
			optsCompany,
			optsContact,
			optsWorkNature,
			optsProgressStatus,
			optsProjectProgress,
			optsProductType,
			optsProductModel,
			workLogContacts,
			workLogColSortDirs,
			tableWidth,
			comWorkLogOrinData,
			comWorkLogSortedData,
			comWorkLogRowsCount,
			comWorkLogDefaultSortIndexes,
			comWorkLogColSortDirs,
			companyInfo,
			isBigSideBar
		} = this.state,
			workLogProps = {
				workLogOrinData,
				workLogSortedData,
				workLogRowsCount,
				workLogDefaultSortIndexes,
				workLogColSortDirs,
				optsCompany,
				optsContact,
				optsWorkNature,
				optsProgressStatus,
				optsProjectProgress,
				optsProductType,
				optsProductModel,
				workLogContacts,
				tableWidth,
				comWorkLogOrinData,
				comWorkLogSortedData,
				comWorkLogRowsCount,
				comWorkLogDefaultSortIndexes,
				comWorkLogColSortDirs
			};


		// 配合route只傳遞有需要的props
		const funcTabRoute = getFuncTabRoute(this.props.location.pathname);


		let propsFromSaleSky,
			// calendar
			calendarProps = "",
			calendarHandlers = "",
			// product
			productProps = "",
			// km
			kmProps = "";

		switch (funcTabRoute) {
			case 'calendar':
				const {
					calendars,
					listsUserGroup,
					personalEvents,
					groupEvents,
					isUserGroupsChecked,
					itemsUserGroup,
					optsJoinCall,
					users,
					datePeriod,
					currentViewDate
				} = this.state;

				calendarProps = {
					calendars, listsUserGroup, personalEvents, groupEvents, isUserGroupsChecked,
					itemsUserGroup, optsJoinCall, users, datePeriod, currentViewDate
				};

				const {
					updateListsUserGroup,
					optsGenerator
				} = this.handlers;

				calendarHandlers = { updateListsUserGroup, optsGenerator };

				break;
			case 'product':
				const {
					productOrinData, productSortedData,
					productRowsCount, productColSortDirs,
					productDefaultSortIndexes,
					productCategories,
					productTreeView,
				} = this.state;

				productProps = {
					productOrinData, productSortedData,
					productRowsCount, productColSortDirs,
					productDefaultSortIndexes,
					productCategories,
					productTreeView
				};
				break;
			case 'km':

				// 過濾km product ========
				// let orinData = [], sortedData = {};

				// if(this.state.productSortedData._data) {

				//   orinData = filter(this.state.productOrinData, 'kmProduct');

				//   let defaultSortIndexes = [];

				//   for (let i = 0, len = orinData.length; i < len; i++) {
				//     defaultSortIndexes.push(i);
				//   }
				//   sortedData = new DataListWrapper(defaultSortIndexes, orinData)
				// }
				// =========================

				// 後來規格變更把km產品與一般產品分開，以最小變動處理
				// 從源頭替換資料來源，屬性名稱則不變
				kmProps = {
					productOrinData: this.state.kmOrinData, // orinData,
					productSortedData: this.state.kmSortedData, // sortedData,
					productColSortDirs: this.state.kmColSortDirs,
					productDefaultSortIndexes: this.state.kmDefaultSortIndexes,
					kmCategories: this.state.kmCategories,
					kmTreeView: this.state.kmTreeView,
					// kmDataOk: this.state.kmDataOk
				};
				break;
			case 'sales-cases':
			case 'shipping-records':
			case 'customer':

				productProps = {
					productOrinData: this.state.productOrinData,
					productSortedData: this.state.productSortedData
				};

				break;
			default:
		}

		// 整合成一包
		propsFromSaleSky = {
			productProps,
			kmProps,
			languageData,
			languageCode
		};

		return (
			<div>
				<SaleSkyDashboardCt
					routeHandler={this.props.routeHandler}
					stateHandler={this.handlers.stateHandler}
					userName={this.props.userName}
					language={this.props.language}
					content={this.props.children}
					routes={this.props.routes}
					pathname={this.props.location.pathname}
					userId={this.props.userId}
					userPhotoSrc={this.props.userPhotoSrc}
					userPermission={this.props.userPermission}
					systemEnvironment={this.props.systemEnvironment}
					logoutHandler={this.props.logoutHandler}
					workLogProps={workLogProps}
					optsContactUpdater={this.handlers.optsContactUpdater}
					optsCompanyUpdater={this.handlers.optsCompanyUpdater}
					workLogDataRefresh={this.handlers.workLogDataRefresh}
					logDataProcesser={this.handlers.logDataProcesser}
					comWorkLogFilter={this.handlers.comWorkLogFilter}
					calendarProps={calendarProps}
					calendarHandlers={calendarHandlers}
					companyInfo={companyInfo}
					isBigSideBar={isBigSideBar}
					onSidebarSizeToggle={this.handlers.onSidebarSizeToggle}
					propsPackageFromSkyFamily={this.props.propsPackageFromSkyFamily}
					propsFromSaleSky={propsFromSaleSky}
				/>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/salesky/routes/SaleSky.jsx